import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import {
    IPieceRateOperation, IPieceRateOperationCreateRequest, IPieceRateOperationUpdateRequest,
    IProductionEntry, IProductionEntryCreateRequest, IProductionEntryUpdateRequest,
    IApproveRangeRequest,
} from '../interfaces/pieceRate.interface';

// T3a (garments people-completion plan, 2026-09-09). Follows the house axios service pattern
// (WageGradeService, PayrollService).
export const PieceRateOperationService = {
    getByInstitution: async (institutionId?: string): Promise<IPieceRateOperation[]> => {
        const instId = institutionId || AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.PIECE_RATE_OPERATION.BY_INSTITUTION(instId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    create: async (data: IPieceRateOperationCreateRequest): Promise<IPieceRateOperation> => {
        const response = await axios.post(ENDPOINTS.PIECE_RATE_OPERATION.BASE, data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    update: async (id: string, data: IPieceRateOperationUpdateRequest): Promise<IPieceRateOperation> => {
        const response = await axios.put(ENDPOINTS.PIECE_RATE_OPERATION.UPDATE(id), data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    delete: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.PIECE_RATE_OPERATION.DELETE(id), {
            headers: AuthService.getAuthHeader(),
        });
    },
};

export const ProductionEntryService = {
    listForUser: async (institutionId: string, userId: string, from: string, to: string): Promise<IProductionEntry[]> => {
        const response = await axios.get(ENDPOINTS.PRODUCTION_ENTRY.BY_USER(institutionId, userId), {
            headers: AuthService.getAuthHeader(),
            params: { from, to },
        });
        return response.data;
    },

    create: async (data: IProductionEntryCreateRequest): Promise<IProductionEntry> => {
        const response = await axios.post(ENDPOINTS.PRODUCTION_ENTRY.BASE, data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    update: async (institutionId: string, id: string, data: IProductionEntryUpdateRequest): Promise<IProductionEntry> => {
        const response = await axios.put(ENDPOINTS.PRODUCTION_ENTRY.UPDATE(institutionId, id), data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    delete: async (institutionId: string, id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.PRODUCTION_ENTRY.DELETE(institutionId, id), {
            headers: AuthService.getAuthHeader(),
        });
    },

    approve: async (institutionId: string, id: string): Promise<IProductionEntry> => {
        const response = await axios.post(ENDPOINTS.PRODUCTION_ENTRY.APPROVE(institutionId, id), {}, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    unapprove: async (institutionId: string, id: string): Promise<IProductionEntry> => {
        const response = await axios.post(ENDPOINTS.PRODUCTION_ENTRY.UNAPPROVE(institutionId, id), {}, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    // R8: per-user, per-range bulk approve -- never institution-wide (ApproveRangeRequest.userId
    // is mandatory on the backend).
    approveRange: async (institutionId: string, data: IApproveRangeRequest): Promise<IProductionEntry[]> => {
        const response = await axios.post(ENDPOINTS.PRODUCTION_ENTRY.APPROVE_RANGE(institutionId), data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },
};
